import { colorsDark } from "assets/theme/colorUtil";
import { TypesColor } from "types/theme";

const colors: TypesColor = colorsDark;

export default colors;
